module.exports = __webpack_public_path__ + "img/antes_despues_130.3384a0a3.png";